(function(w,d,$){
  'use strict';

  $(function(){
    // カテゴリリスト整形 カレントメニュー
    (function($menu){
      var content = location.pathname.replace(/^(\/[^/]+\/)(.+)?/,'$1'),
          $allLink = $('<div><h4><a/></h4></div>').attr({class:'title list_title1 block_title'}),
          cateLink = $('.breadcrumbs li:eq(2) a').attr('href');
      cateLink = (cateLink && cateLink.search('mode=list') != -1 )? cateLink.replace(/main\.php/,''): null;
      $('a',$allLink).attr({href:content}).text('ALL');
      $menu.each(function(){
        $allLink.clone().prependTo( $('.list_cat',this) );
        $(this).currentMenu({
          url:cateLink||location.pathname+location.search
        });
      });
    }( $('div.layout_b_pattern6') ));


    // 一覧表示整形
    (function(_){
      _.$lists.each(function(){
        var $this = $(this),
            $catelink = $this.find('.catetitle a').addClass('button button-xsmall button-inverse'),
            thumbSrc = $this.find('.thum_img img').attr('src'),
            rawImagePath = thumbSrc.replace(/thumb-([^/]+)(\.jpe?g|gif|png)$/i,'$1$2');
        $this.find('.catetitle').html($catelink).insertAfter($this.find('.thum_img'));
        $this.find('.thum_img').css({
          'background': 'url('+rawImagePath+') no-repeat center',
          'background-size':'cover'
        }).find('img').attr({
          src: rawImagePath
        }).css({
          width:'100%',
          height:'100%',
          opacity:'0'
        });
      });

    }({
      is_list:$('#main > .element_list').length > 0,
      $lists: $('.element_list .artloop')
    }));

  });

}(window,document,jQuery));